import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    editing: undefined,
    nextFolio: undefined,
    record: {
      attention: {
        attentionDate: null,
        attentionDateVisible: true,
        previousAdvisory: false,
        advisoryNumber: "",
        advisoryProvider: "",
        startTime: "",
        endTime: "",
        minutes: "",
        hearFromOrg: "",
        specificHear: "",
        initialYear: null,
        isRelated: false
      },
      synthesis: {
        country: "",
        state: "",
        stateVisible: true,
        municipality: "",
        municipalityVisible: true,
        matterVisible: true,
        otherMatter: "",
        matter: {
          administrative: {
            isSelected: false,
            text: "Administrativo"
          },
          agrarian: {
            isSelected: false,
            text: "Agrario"
          },
          environmental: {
            isSelected: false,
            text: "Ambiental"
          },
          civil: {
            isSelected: false,
            text: "Civil"
          },
          humanRights: {
            isSelected: false,
            text: "Derechos humanos"
          },
          family: {
            isSelected: false,
            text: "Familiar"
          },
          labor: {
            isSelected: false,
            text: "Laboral"
          },
          trade: {
            isSelected: false,
            text: "Mercantil"
          },
          other: {
            isSelected: false,
            text: "Otro"
          },
          migration: {
            isSelected: false,
            text: "Migración"
          },
          penal: {
            isSelected: false,
            text: "Penal"
          },
          health: {
            isSelected: false,
            text: "Salud"
          },
          womenViolence: {
            isSelected: false,
            text: "Violencia contra la mujer"
          }
        },
        project: {
          coahuila: {
            isSelected: false,
            text: "Desaparecidos en Coahuila"
          },
          vdh: {
            isSelected: false,
            text: "Otras VDH"
          },
          otherStates: {
            isSelected: false,
            text: "Desaparecidos en otros estados"
          }
        },
        interventionVisible: true,
        intervention: {
          advisory: {
            isSelected: false,
            text: "Asesoría"
          },
          management: {
            isSelected: false,
            text: "Gestión"
          },
          canalization: {
            isSelected: false,
            text: "Canalización"
          }
        },
        referredVisible: true,
        otherReferrence: "",
        referred: {
          ampestatal: {
            isSelected: false,
            text: "AMP estatal"
          },
          cedhc: {
            isSelected: false,
            text: "CEDHC"
          },
          defenders: {
            isSelected: false,
            text: "Mecanismo de defensores"
          },
          ampfederal: {
            isSelected: false,
            text: "AMP federal"
          },
          ceavco: {
            isSelected: false,
            text: "CEAV Coahuila"
          },
          cedh: {
            isSelected: false,
            text: "CEDH Estado"
          },
          estatal: {
            isSelected: false,
            text: "Dependencia estatal"
          },
          obispado: {
            isSelected: false,
            text: "Obispado"
          },
          pjf: {
            isSelected: false,
            text: "Poder judicial federal"
          },
          cndh: {
            isSelected: false,
            text: "CNDH"
          },
          conciliacion: {
            isSelected: false,
            text: "Conciliación y arbitraje"
          },
          defensoria: {
            isSelected: false,
            text: "Defensoría jurídica"
          },
          ongosc: {
            isSelected: false,
            text: "ONG/OSC"
          },
          federal: {
            isSelected: false,
            text: "Dependencia federal"
          },
          municipal: {
            isSelected: false,
            text: "Dependencia municipal"
          },
          segsocial: {
            isSelected: false,
            text: "Inst. Seg. Social"
          },
          intfin: {
            isSelected: false,
            text: "Institución financiera"
          },
          work: {
            isSelected: false,
            text: "Lugar donde trabaja"
          },
          procuraduria: {
            isSelected: false,
            text: "Procuraduría especializada"
          },
          private: {
            isSelected: false,
            text: "Profesional privado"
          },
          other: {
            isSelected: false,
            text: "Otro"
          }
        },
        management: ""
      },
      petitioner: {
        name: "",
        cellphone: "",
        mail: "",
        age: "",
        ageVisible: true,
        sex: "",
        sexVisible: true,
        genre: "",
        occupation: "",
        occupationVisible: true,
        otherOccupation: "",
        civilStatus: "",
        civilStatusVisible: true,
        ethnicity: ""
      },
      reason: {
        summary: "",
        registeredCase: "",
        caseNumber: "",
        caseName: ""
      },
      postal: {
        url: "",
        fecha: "",
        etag: ""
      },
      folio: null,
      relatedAdvisory: "",
      place: undefined,
      address: undefined,
      lat: undefined,
      lng: undefined,
      victims: [],
      updates: [],
      public: true,
      edit_reason: "",
      edit_comments: ""
    },
    victims: [
      {
        victimFolio: 1,
        visibleFolio: "",
        victimName: "",
        nationality: "",
        postal: {
          url: "",
          fecha: "",
          etag: ""
        },
        photo: "",
        country: "",
        disappearancePlace: "",
        municipality: "",
        age: "",
        lastSeenDate: null,
        status: "",
        physicalDescription: "",
        factDescription: "",
        place: "",
        address: undefined,
        lat: undefined,
        lng: undefined
      }
    ],
    victimImages: [],
    host: "https://admin-frayjuandelarios.datacivica.org/",
    reports: [],
    filteredReports: [],
    filters: {},
    carousel: [],
    isLoading: false,
    showVictim: false,
    searchDialog: false,
    user: {
      email: null,
      role: null,
      name: null,
      isAuthenticated: true,
      permission: null
    },
    userEdit: {
      email: "",
      role: "",
      name: "",
      isAuthenticated: false,
      profileImg: {},
      permission: {}
    },
    userList: [],
    currentToken: "",

    getReportsAsyncPending: false,
    getReportsAsyncStatusCode: null,

    createReportAsyncPending: false,
    createReportAsyncStatusCode: null,
    createReportAsyncData: null,

    updateReportAsyncPending: false,
    updateReportAsyncStatusCode: null,
    updateReportAsyncData: null,

    deleteReportAsyncPending: false,
    deleteReportAsyncStatusCode: null,
    deleteReportAsyncData: null,

    createUserAsyncPending: false,
    createUserAsyncStatusCode: null,
    createUserAsyncData: null,

    getUsersAsyncPending: false,
    getUsersAsyncStatusCode: null,
    getUsersAsyncData: null,

    updateUsersAsyncPending: false,
    updateUsersAsyncStatusCode: null,
    updateUsersAsyncData: null,

    updateUsersPasswordAsyncPending: false,
    updateUsersPasswordAsyncStatusCode: null,
    updateUsersPasswordAsyncData: null,

    uploadImageAsyncPending: false,
    uploadImageAsyncStatusCode: null,
    uploadImageAsyncData: null,

    updateCsvAsyncPending: false,
    updateCsvAsyncStatusCode: null,
    updateCsvAsyncData: null,

    loginAsyncPending: false,
    loginAsyncStatusCode: null,
    loginAsyncData: null
  },
  getters: {
    record: state => state.record,
    victims: state => state.victims,
    reports: state => state.reports,
    filteredReports: state => state.filteredReports,
    filters: state => state.filters,
    userList: state => state.userList,
    userEdit: state => state.userEdit,
    findVictim: state => mod => {
      let modVictim = state.victims.find(d => d.victimFolio === mod.folio);
      modVictim[mod.prop] = mod.val;
      return modVictim;
    },
    user: state => state.user
  },
  mutations: {
    setEditionState(state, edit) {
      state.editing = edit;
    },
    setIsLoadingState(state, isLoading) {
      state.isLoading = isLoading;
    },
    setRecord(state, item) {
      state.record = item;
      state.record._id = state.record["_id"];
    },
    setVictims(state, arr) {
      state.victims = arr;
    },
    resetRecord(state) {
      state.record = {
        attention: {
          attentionDate: null,
          attentionDateVisible: true,
          previousAdvisory: false,
          advisoryNumber: "",
          advisoryProvider: "",
          startTime: "",
          endTime: "",
          minutes: "",
          hearFromOrg: "",
          specificHear: "",
          initialYear: null,
          isRelated: false
        },
        synthesis: {
          country: "",
          state: "",
          stateVisible: true,
          municipality: "",
          municipalityVisible: true,
          matterVisible: true,
          otherMatter: "",
          matter: {
            administrative: {
              isSelected: false,
              text: "Administrativo"
            },
            agrarian: {
              isSelected: false,
              text: "Agrario"
            },
            environmental: {
              isSelected: false,
              text: "Ambiental"
            },
            civil: {
              isSelected: false,
              text: "Civil"
            },
            humanRights: {
              isSelected: false,
              text: "Derechos humanos"
            },
            family: {
              isSelected: false,
              text: "Familiar"
            },
            labor: {
              isSelected: false,
              text: "Laboral"
            },
            trade: {
              isSelected: false,
              text: "Mercantil"
            },
            other: {
              isSelected: false,
              text: "Otro"
            },
            migration: {
              isSelected: false,
              text: "Migración"
            },
            penal: {
              isSelected: false,
              text: "Penal"
            },
            health: {
              isSelected: false,
              text: "Salud"
            },
            womenViolence: {
              isSelected: false,
              text: "Violencia contra la mujer"
            }
          },
          project: {
            coahuila: {
              isSelected: false,
              text: "Desaparecidos en Coahuila"
            },
            vdh: {
              isSelected: false,
              text: "Otras VDH"
            },
            otherStates: {
              isSelected: false,
              text: "Desaparecidos en otros estados"
            }
          },
          interventionVisible: true,
          intervention: {
            advisory: {
              isSelected: false,
              text: "Asesoría"
            },
            management: {
              isSelected: false,
              text: "Gestión"
            },
            canalization: {
              isSelected: false,
              text: "Canalización"
            }
          },
          referredVisible: true,
          otherReferrence: "",
          referred: {
            ampestatal: {
              isSelected: false,
              text: "AMP estatal"
            },
            cedhc: {
              isSelected: false,
              text: "CEDHC"
            },
            defenders: {
              isSelected: false,
              text: "Mecanismo de defensores"
            },
            ampfederal: {
              isSelected: false,
              text: "AMP federal"
            },
            ceavco: {
              isSelected: false,
              text: "CEAV Coahuila"
            },
            cedh: {
              isSelected: false,
              text: "CEDH Estado"
            },
            estatal: {
              isSelected: false,
              text: "Dependencia estatal"
            },
            obispado: {
              isSelected: false,
              text: "Obispado"
            },
            pjf: {
              isSelected: false,
              text: "Poder judicial federal"
            },
            cndh: {
              isSelected: false,
              text: "CNDH"
            },
            conciliacion: {
              isSelected: false,
              text: "Conciliación y arbitraje"
            },
            defensoria: {
              isSelected: false,
              text: "Defensoría jurídica"
            },
            ongosc: {
              isSelected: false,
              text: "ONG/OSC"
            },
            federal: {
              isSelected: false,
              text: "Dependencia federal"
            },
            municipal: {
              isSelected: false,
              text: "Dependencia municipal"
            },
            segsocial: {
              isSelected: false,
              text: "Inst. Seg. Social"
            },
            intfin: {
              isSelected: false,
              text: "Institución financiera"
            },
            work: {
              isSelected: false,
              text: "Lugar donde trabaja"
            },
            procuraduria: {
              isSelected: false,
              text: "Procuraduría especializada"
            },
            private: {
              isSelected: false,
              text: "Profesional privado"
            },
            other: {
              isSelected: false,
              text: "Otro"
            }
          },
          management: ""
        },
        petitioner: {
          name: "",
          cellphone: "",
          mail: "",
          age: "",
          ageVisible: true,
          sex: "",
          sexVisible: true,
          genre: "",
          occupation: "",
          occupationVisible: true,
          otherOccupation: "",
          civilStatus: "",
          civilStatusVisible: true,
          ethnicity: ""
        },
        reason: {
          summary: "",
          registeredCase: "",
          caseNumber: "",
          caseName: ""
        },
        postal: {
          url: "",
          fecha: "",
          etag: ""
        },
        folio: null,
        relatedAdvisory: "",
        place: undefined,
        address: undefined,
        lat: undefined,
        lng: undefined,
        victims: [],
        updates: [],
        public: true,
        edit_reason: "",
        edit_comments: ""
      };
    },
    resetVictim(state) {
      state.victims = [
        {
          victimFolio: 1,
          visibleFolio: "",
          victimName: "",
          nationality: "",
          postal: {
            url: "",
            fecha: "",
            etag: ""
          },
          photo: "",
          country: "",
          disappearancePlace: "",
          municipality: "",
          age: "",
          lastSeenDate: null,
          status: "",
          physicalDescription: "",
          factDescription: "",
          place: undefined,
          address: undefined,
          lat: undefined,
          lng: undefined
        }
      ];
    },
    resetVictimImages(state) {
      state.victimImages = [];
    },
    setUser(state, user) {
      state.user = user;
      state.user.isAuthenticated = true;
    },
    resetUser(state) {
      state.user = {
        email: null,
        role: null,
        isAuthenticated: false,
        name: null,
        permission: null
      };
      localStorage.clear();
    },
    setUserEdit(state, userInfo) {
      state.userEdit = userInfo;
      state.userEdit.id = userInfo["_id"];
    },
    setUserList(state, list) {
      state.userList = list;
    },
    SET_GETREPORTS_PENDING(state, payload) {
      state.getReportsAsyncPending = payload.pending;
    },
    SET_GETREPORTS_SUCCESS(state, payload) {
      state.getReportsAsyncStatusCode = payload.statusCode;
      state.getReportsAsyncPending = payload.pending;
      state.reports = payload.data.result;
      const filters = {};
      state.reports.map(report => (filters[report.type] = false));
      state.filteredReports = state.reports;
      state.filters = filters;
      state.nextFolio = Number(payload.data.folio) + 1;
    },
    SET_GETREPORTS_FAILURE(state, payload) {
      state.getReportsAsyncStatusCode = payload.statusCode;
    },

    SET_CREATEREPORT_PENDING(state, payload) {
      state.createReportAsyncPending = payload.pending;
    },
    SET_CREATEREPORT_SUCCESS(state, payload) {
      state.createReportAsyncStatusCode = payload.statusCode;
      state.createReportAsyncData = payload.data;
      state.createReportAsyncPending = payload.pending;
    },
    SET_CREATEREPORT_FAILURE(state, payload) {
      state.createReportAsyncStatusCode = payload.statusCode;
    },
    SET_UPDATEREPORT_PENDING(state, payload) {
      state.updateReportAsyncPending = payload.pending;
    },
    SET_UPDATEREPORT_SUCCESS(state, payload) {
      state.updateReportAsyncStatusCode = payload.statusCode;
      state.updateReportAsyncData = payload.data;
      state.updateReportAsyncPending = payload.pending;
    },
    SET_UPDATEREPORT_FAILURE(state, payload) {
      state.updateReportAsyncStatusCode = payload.statusCode;
    },

    SET_DELETEREPORT_PENDING(state, payload) {
      state.deleteReportAsyncPending = payload.pending;
    },
    SET_DELETEREPORT_SUCCESS(state, payload) {
      state.deleteReportAsyncStatusCode = payload.statusCode;
      state.deleteReportAsyncData = payload.data;
      state.deleteReportAsyncPending = payload.pending;
    },
    SET_DELETEREPORT_FAILURE(state, payload) {
      state.deleteReportAsyncStatusCode = payload.statusCode;
    },

    SET_CREATEUSER_PENDING(state, payload) {
      state.createUserAsyncPending = payload.pending;
    },
    SET_CREATEUSERS_SUCCESS(state, payload) {
      state.createUsersAsyncStatusCode = payload.statusCode;
      state.createUsersAsyncData = payload.data;
      state.createUsersAsyncPending = payload.pending;
    },
    SET_CREATEUSERS_FAILURE(state, payload) {
      state.createUsersAsyncStatusCode = payload.statusCode;
    },

    SET_GETUSERS_PENDING(state, payload) {
      state.getUsersAsyncPending = payload.pending;
    },
    SET_GETUSERS_SUCCESS(state, payload) {
      state.getUsersAsyncStatusCode = payload.statusCode;
      state.getUsersAsyncData = payload.data;
      state.getUsersAsyncPending = payload.pending;
      state.userList = payload.data.result;
    },
    SET_GETUSERS_FAILURE(state, payload) {
      state.getUsersAsyncStatusCode = payload.statusCode;
    },

    SET_UPDATEUSERS_PENDING(state, payload) {
      state.updateUsersAsyncPending = payload.pending;
    },
    SET_UPDATEUSERS_SUCCESS(state, payload) {
      state.updateUsersAsyncStatusCode = payload.statusCode;
    },
    SET_UPDATEUSERS_FAILURE(state, payload) {
      state.updateUsersAsyncStatusCode = payload.statusCode;
    },

    SET_UPDATEPASSWORD_PENDING(state, payload) {
      state.updateUsersPasswordAsyncPending = payload.pending;
    },
    SET_UPDATEPASSWORD_SUCCESS(state, payload) {
      state.updateUsersPasswordAsyncStatusCode = payload.statusCode;
    },
    SET_UPDATEPASSWORD_FAILURE(state, payload) {
      state.updateUsersPasswordAsyncStatusCode = payload.statusCode;
    },

    SET_DELETEUSERS_PENDING(state, payload) {
      state.deleteUsersAsyncPending = payload.pending;
    },
    SET_DELETEUSERS_SUCCESS(state, payload) {
      state.deleteUsersAsyncStatusCode = payload.statusCode;
    },
    SET_DELETEUSERS_FAILURE(state, payload) {
      state.deleteUsersAsyncStatusCode = payload.statusCode;
    },

    SET_UPLOADIMAGE_PENDING(state, payload) {
      state.uploadImageAsyncPending = payload.pending;
    },
    SET_UPLOADIMAGE_SUCCESS(state, payload) {
      state.uploadImageAsyncStatusCode = payload.statusCode;
      state.uploadImageAsyncData = payload.data;
      state.uploadImageAsyncPending = payload.pending;
    },
    SET_UPLOADIMAGE_FAILURE(state, payload) {
      state.uploadImageAsyncStatusCode = payload.statusCode;
    },
    SET_UPDATECSV_PENDING(state, payload) {
      state.updateCsvAsyncPending = payload.pending;
    },
    SET_UPDATECSV_SUCCESS(state, payload) {
      state.updateCsvAsyncStatusCode = payload.statusCode;
      state.updateCsvAsyncData = payload.data;
      state.updateCsvAsyncPending = payload.pending;
    },
    SET_UPDATECSV_FAILURE(state, payload) {
      state.updateCsvAsyncStatusCode = payload.statusCode;
    },
    SET_LOGIN_PENDING(state, payload) {
      state.loginAsyncPending = payload.pending;
    },
    SET_LOGIN_SUCCESS(state, payload) {
      state.loginAsyncStatusCode = payload.statusCode;
      state.loginAsyncData = payload.data;
      state.loginAsyncPending = payload.pending;
    },
    SET_LOGIN_FAILURE(state, payload) {
      state.loginAsyncStatusCode = payload.statusCode;
    },
    updateVictimsAdvisory(state, allVictims) {
      state.record.victims = allVictims;
    },
    showVictimForm(state, value) {
      state.showVictim = value;
    },
    updateVictims(state, info) {
      if (info.operation === "add") {
        state.victims.push({
          victimFolio: info.currentFolio + 1,
          visibleFolio: state.editing
            ? `C${state.record.folio ? state.record.folio : ""}V${info.currentFolio + 1}`
            : "",
          victimName: "",
          postal: {
            url: "",
            fecha: "",
            etag: ""
          },
          photo: "",
          country: "",
          disappearancePlace: "",
          municipality: "",
          age: "",
          lastSeenDate: null,
          status: "",
          physicalDescription: ""
        });
      } else {
        state.victims = state.victims.filter(
          item => item.victimFolio !== info.currentFolio
        );
        console.log("UPDATE VICTIMS");
        state.victims.forEach((victim, key) => {
          Vue.set(victim, "victimFolio", key + 1);
          Vue.set(victim, "visibleFolio", `C${state.record.folio}V${Number(key) + 1}`)
        });
        state.victims = state.victims;
      }
    },
    updatePhoto(state, photoInfo) {
      state.victims = [
        ...state.victims.filter(
          element => element.victimFolio !== photoInfo.folio
        ),
        this.getters.findVictim(photoInfo)
      ];
    },
    // Attention
    updateAttentionDate(state, date) {
      state.record.attention.attentionDate = date;
    },
    updateAttentionDateVisible(state, value) {
      state.record.attention.attentionDateVisible = value;
    },
    updateAdvisoryNumber(state, number) {
      state.record.attention.advisoryNumber = number;
    },
    updateAdvisoryProvider(state, name) {
      state.record.attention.advisoryProvider = name;
    },
    updateStartTime(state, time) {
      state.record.attention.startTime = time;
    },
    updateEndTime(state, time) {
      state.record.attention.endTime = time;
    },
    updateHearFromOrg(state, option) {
      state.record.attention.hearFromOrg = option;
    },
    updateSpecificHear(state, value) {
      state.record.attention.specificHear = value;
    },
    updateInitialYear(state, year) {
      state.record.attention.initialYear = year;
    },
    updateAttentionMinutes(state, minutes) {
      state.record.attention.minutes = minutes;
    },
    updateAttentionRelation(state, related) {
      state.record.attention.isRelated = related;
    },
    updateSearchDialogStatus(state, value) {
      state.searchDialog = value;
    },
    // Synthesis
    updateCountry(state, _country) {
      state.record.synthesis.country = _country;
    },
    updateCountryVisible(state, value) {
      state.record.synthesis.countryVisible = value;
    },
    updateState(state, _state) {
      state.record.synthesis.state = _state;
    },
    updateStateVisible(state, value) {
      state.record.synthesis.stateVisible = value;
    },
    updateMunicipality(state, mun) {
      state.record.synthesis.municipality = mun;
    },
    updateMunicipalityVisible(state, value) {
      state.record.synthesis.municipalityVisible = value;
    },
    updateMatter(state, matters) {
      // Reset all
      Object.keys(state.record.synthesis.matter).forEach(key => {
        state.record.synthesis.matter[key].isSelected = false;
      });
      // Mark current
      matters.forEach(val => {
        state.record.synthesis.matter[val].isSelected = true;
      });
    },
    updateMatterVisible(state, value) {
      state.record.synthesis.matterVisible = value;
    },
    updateOtherMatter(state, value) {
      state.record.synthesis.otherMatter = value;
    },
    updateProject(state, projects) {
      // Reset all
      Object.keys(state.record.synthesis.project).forEach(key => {
        state.record.synthesis.project[key].isSelected = false;
      });
      // Mark current
      projects.forEach(val => {
        state.record.synthesis.project[val].isSelected = true;
      });
    },
    updateIntervention(state, interventions) {
      // Reset all
      Object.keys(state.record.synthesis.intervention).forEach(key => {
        state.record.synthesis.intervention[key].isSelected = false;
      });
      // Mark current
      interventions.forEach(val => {
        state.record.synthesis.intervention[val].isSelected = true;
      });
    },
    updateInterventionVisible(state, value) {
      state.record.synthesis.interventionVisible = value;
    },
    updateReferences(state, references) {
      // Reset all
      Object.keys(state.record.synthesis.referred).forEach(key => {
        state.record.synthesis.referred[key].isSelected = false;
      });
      // Mark current
      references.forEach(val => {
        state.record.synthesis.referred[val].isSelected = true;
      });
    },
    updateReferredVisible(state, value) {
      state.record.synthesis.referredVisible = value;
    },
    updateOtherReferrence(state, value) {
      state.record.synthesis.otherReferrence = value;
    },
    updateManagement(state, value) {
      state.record.synthesis.management = value;
    },
    // Petitioner
    updatePetitionerName(state, name) {
      state.record.petitioner.name = name;
    },
    updateCellphone(state, phone) {
      state.record.petitioner.cellphone = phone;
    },
    updateMail(state, mail) {
      state.record.petitioner.mail = mail;
    },
    updateAge(state, age) {
      state.record.petitioner.age = age;
    },
    updateAgeVisible(state, value) {
      state.record.petitioner.ageVisible = value;
    },
    updatePetitionerSex(state, sex) {
      state.record.petitioner.sex = sex;
    },
    updatePetitionerGenre(state, genre) {
      state.record.petitioner.genre = genre;
    },
    updateSexVisible(state, status) {
      state.record.petitioner.sexVisible = status;
    },
    updateOccupation(state, occupation) {
      state.record.petitioner.occupation = occupation;
    },
    updateOccupationVisible(state, value) {
      state.record.petitioner.occupationVisible = value;
    },
    updateOtherOccupation(state, value) {
      state.record.petitioner.otherOccupation = value;
    },
    updateCivilStatus(state, status) {
      state.record.petitioner.civilStatus = status;
    },
    updateCivilStatusVisible(state, value) {
      state.record.petitioner.civilStatusVisible = value;
    },
    updateEthnicity(state, value) {
      state.record.petitioner.ethnicity = value;
    },
    // Reason
    updateSummary(state, summary) {
      state.record.reason.summary = summary;
    },
    updateRegisteredCase(state, register) {
      state.record.reason.registeredCase = register;
    },
    updateCaseNumber(state, number) {
      state.record.reason.caseNumber = number;
    },
    updateCaseName(state, name) {
      state.record.reason.caseName = name;
    },
    // Victim
    updateVictimName(state, nameInfo) {
      state.victims = [
        ...state.victims.filter(
          element => element.victimFolio !== nameInfo.folio
        ),
        this.getters.findVictim(nameInfo)
      ];
    },
    updateVictimNationality(state, nationalityInfo) {
      state.victims = [
        ...state.victims.filter(
          element => element.victimFolio !== nationalityInfo.folio
        ),
        this.getters.findVictim(nationalityInfo)
      ];
    },
    updateVictimCountry(state, countryInfo) {
      state.victims = [
        ...state.victims.filter(
          element => element.victimFolio !== countryInfo.folio
        ),
        this.getters.findVictim(countryInfo)
      ];
    },
    updateDisappearancePlace(state, placeInfo) {
      state.victims = [
        ...state.victims.filter(
          element => element.victimFolio !== placeInfo.folio
        ),
        this.getters.findVictim(placeInfo)
      ];
    },
    updateVictimMunicipality(state, munInfo) {
      state.victims = [
        ...state.victims.filter(
          element => element.victimFolio !== munInfo.folio
        ),
        this.getters.findVictim(munInfo)
      ];
    },
    updateVictimAge(state, ageInfo) {
      state.victims = [
        ...state.victims.filter(
          element => element.victimFolio !== ageInfo.folio
        ),
        this.getters.findVictim(ageInfo)
      ];
    },
    updateLastSeenDate(state, dateInfo) {
      state.victims = [
        ...state.victims.filter(
          element => element.victimFolio !== dateInfo.folio
        ),
        this.getters.findVictim(dateInfo)
      ];
    },
    updateVictimStatus(state, statusInfo) {
      state.victims = [
        ...state.victims.filter(
          element => element.victimFolio !== statusInfo.folio
        ),
        this.getters.findVictim(statusInfo)
      ];
    },
    updatePhysicalDescription(state, descriptionInfo) {
      state.victims = [
        ...state.victims.filter(
          element => element.victimFolio !== descriptionInfo.folio
        ),
        this.getters.findVictim(descriptionInfo)
      ];
    },
    updateFactDescription(state, factInfo) {
      state.victims = [
        ...state.victims.filter(
          element => element.victimFolio !== factInfo.folio
        ),
        this.getters.findVictim(factInfo)
      ];
    },
    updatePlace(state, place) {
      state.record.place = place;
    },
    updateAddress(state, address) {
      state.record.address = address;
    },
    updateLat(state, lat) {
      state.record.lat = lat;
    },
    updateLng(state, lng) {
      state.record.lng = lng;
    },
    updateVictimPlace(state, placeInfo) {
      state.victims = [
        ...state.victims.filter(
          element => element.victimFolio !== placeInfo.folio
        ),
        this.getters.findVictim(placeInfo)
      ];
    },
    updateRelatedAdvisory(state, relation) {
      state.record.relatedAdvisory = relation;
    },
    updateEditReason(state, edit_reason) {
      state.record["edit_reason"] = edit_reason;
    },
    updateEditComments(state, edit_comments) {
      state.record["edit_comments"] = edit_comments;
    },
    updatePublic(state, _public) {
      state.record.public = _public;
    },
    updateUserName(state, _name) {
      state.userEdit.name = _name;
    },
    updateUserEmail(state, _email) {
      state.userEdit.email = _email;
    },
    updateUserRole(state, _role) {
      state.userEdit.role = _role;
    },
    updateUserPassword(state, _password) {
      state.userEdit.password = _password;
    },
    updateUserProfileImg(state, _profileImg) {
      state.userEdit.profileImg = _profileImg;
    },
    updateCarouselImages(state, value) {
      state.carousel = value;
    },
    updateAllVictimImages(state, img) {
      state.victimImages.push(img);
    }
  },
  actions: {
    getReports({ state, commit }) {
      commit("SET_GETREPORTS_PENDING", { pending: true });
      axios
        .get(state.host + "api/v1/reports", {
          params: {}
        })
        .then(response => {
          commit("SET_GETREPORTS_SUCCESS", {
            pending: false,
            statusCode: response.status,
            data: response.data
          });
        })
        .catch(error => {
          commit("SET_GETREPORTS_FAILURE", {
            pending: false,
            statusCode: error.status
          });
        });
    },
    createReport({ state, commit }) {
      state.record.updates.push({
        when: new Date(),
        who: state.user.email,
        changes: "Registro inicial",
        comments: "Registro inicial"
      });
      commit("SET_CREATEREPORT_PENDING", { pending: true });
      return axios.post(state.host + "api/v1/reports", {
        record: state.record
      });
    },
    updateReport({ state, commit }) {
      state.record.updates.push({
        when: new Date(),
        who: state.user.email,
        changes:
          state.record["edit_reason"] === "update"
            ? "Actualización del caso"
            : "Corrección de errores",
        comments: state.record["edit_comments"]
      });

      commit("SET_UPDATEREPORT_PENDING", { pending: true });
      return axios.put(state.host + "api/v1/reports", {
        record: state.record
      });
    },
    deleteReport({ state, commit }) {
      commit("SET_DELETEREPORT_PENDING", { pending: true });
      return axios.delete(state.host + "api/v1/reports", {
        params: {
          reportId: state.record._id
        }
      });
    },
    getUser({ state }) {
      return axios.get(state.host + "api/v1/getSessionUser");
    },
    createUser({ state, commit }) {
      commit("SET_CREATEUSER_PENDING", { pending: true });
      return axios.post(state.host + "api/v1/register", state.userEdit);
    },
    updateUser({ state, commit }) {
      commit("SET_UPDATEUSERS_PENDING", { pending: true });
      return axios.put(state.host + "api/v1/updateUser", {
        features: state.userEdit
      });
    },
    updatePassword({ state, commit }) {
      commit("SET_UPDATEPASSWORD_PENDING", { pending: true });
      return axios.put(state.host + "api/v1/updatePassword", {
        features: state.userEdit
      });
    },
    deleteUser({ state, commit }) {
      commit("SET_DELETEUSER_PENDING", { pending: true });
      return axios.delete(state.host + "api/v1/deleteUser", {
        params: {
          id: state.userEdit._id
        }
      });
    },
    getUserList({ state, commit }) {
      commit("SET_GETUSERS_PENDING", { pending: true });
      return axios
        .get(state.host + "api/v1/getUserList")
        .then(response => {
          commit("SET_GETUSERS_SUCCESS", {
            pending: false,
            statusCode: response.status,
            data: response.data
          });
        })
        .catch(error => {
          commit("SET_GETUSERS_FAILURE", {
            pending: false,
            statusCode: error.status
          });
        });
    },
    uploadImage({ state, commit }, imageData) {
      commit("SET_UPLOADIMAGE_PENDING", { pending: true });
      return axios.post(state.host + "api/v1/images", imageData);
    },
    uploadPicture({ state, commit }, pictureData) {
      commit("setIsLoadingState", true);
      commit("updateAllVictimImages", {
        folio: pictureData.victimFolio,
        url: pictureData.data.file
      });
      axios
        .post(state.host + "api/v1/images", pictureData.data)
        .then(response => {
          const updateVictim = {
            folio: pictureData.victimFolio,
            prop: "photo",
            val: response.data.url + "?" + new Date().getTime()
          };

          commit("updatePhoto", updateVictim);
          commit("setIsLoadingState", false);
        })
        .catch(() => {
          commit("setIsLoadingState", false);
        });
    },
    uploadUserProfileImg({ state, commit }, imageData) {
      commit("setIsLoadingState", true);
      axios
        .post(state.host + "api/v1/images", imageData)
        .then(response => {
          commit("updateUserProfileImg", response.data);
          commit("setIsLoadingState", false);
        })
        .catch(() => {
          commit("setIsLoadingState", false);
        });
    },
    updateCsv({ state, commit }) {
      commit("SET_UPDATECSV_PENDING", { pending: true });

      return axios.post(state.host + "api/v1/generateCsv");
    },
    login({ state, commit }, userData) {
      commit("SET_LOGIN_PENDING", { pending: true });
      return axios.post(
        state.host + "api/v1/login",
        {
          email: userData.email,
          password: userData.password
        },
        {
          withCredentials: true
        }
      );
    },
    logout({ state }) {
      return axios.get(state.host + "api/v1/logout");
    },
    addToken({ state }) {
      // commit('SET_ADDTOKEN_PENDING', { pending: true })
      return axios.post(state.host + "api/v1/token", {
        email: state.user.email,
        role: state.user.role,
        token: state.currentToken
      });
    },
    sendPushNotification({ state }, notification) {
      // commit('SET_ADDTOKEN_PENDING', { pending: true })
      return axios.post(state.host + "api/v1/notification", {
        notification: notification
      });
    }
  }
});
